import { render, staticRenderFns } from "./DetailVenue.vue?vue&type=template&id=235a2303&scoped=true&"
import script from "./DetailVenue.vue?vue&type=script&lang=js&"
export * from "./DetailVenue.vue?vue&type=script&lang=js&"
import style0 from "./DetailVenue.vue?vue&type=style&index=0&id=235a2303&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a2303",
  null
  
)

export default component.exports